export default {
  LOAD_DATA: 'Load Data',
  LOAD_EMPLOYEE_DATA: 'Load Employee Data',
  LOAD_DATA_PROVIDER: 'Shares Provider',
  LOAD_DATA_TEMPLATE: 'Template',
  LOAD_DATA_UPLOADED_SUCCESFULLY: 'Last file was successfully %TYPE% on: %DATE%',
  LOAD_DATA_UPLOADED_WITH_ERRORS: 'Last file was %TYPE% with errors: %LINK%',
  LOAD_DATA_UPLOADED_FILE_VALIDATION_STARTED: 'File validation has started',
};
